import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { PayvalidaFeatureFlagService } from './payvalida-feature-flag.service';
import { FLAGS_NAME, GENERAL_CONSTANTS } from '../core/constants/General-constants';
import { Transaction } from '../models';
import { environment } from 'src/environments/environment';
import { captureException } from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class IframeService {
  constructor(private readonly jwt: JwtHelperService, private readonly featureFlagService: PayvalidaFeatureFlagService) { }

  private token: string;
  private isIframe: boolean;
  private autoExposeTcFormFeatureFlag: boolean;

  getToken() {
    if (!this.token) this.token = new URLSearchParams(window.location.search).get('token');

    return this.token;
  }

  getAndDecodeToken = (): Transaction => this.jwt.decodeToken(this.getToken());

  getIsIframe() {
    if (this.isIframe === undefined) this.isIframe = window !== window.parent;

    if (!this.isIframe && environment.production != true) {
      let userAgent = navigator.userAgent;

      if (userAgent.includes('; wv)') || (userAgent.includes('Mobile/') && !userAgent.includes('Safari'))) this.isIframe = true;
    }

    return this.isIframe;
  }

  async getAutoExposeTcFormFeatureFlag() {
    if (this.autoExposeTcFormFeatureFlag === undefined) {
      this.autoExposeTcFormFeatureFlag = await this.featureFlagService
        .getFeatureFlagValue(this.getAndDecodeToken().MERCHANT_ID, FLAGS_NAME.AUTO_EXPOSE_TC_FORM_FF, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM)
        .toPromise();
    }

    return this.autoExposeTcFormFeatureFlag ?? false;
  }

  async showAutoExposedTcForm() {
    try {
      const isIframe = this.getIsIframe();
      const autoExposeTcFormFeatureFlag = await this.getAutoExposeTcFormFeatureFlag();

      return isIframe && autoExposeTcFormFeatureFlag;
    } catch (e) {
      captureException(e, { tags: { custom: true } });

      return false;
    }
  }
}
